import { render } from "./langganan-chip.vue?vue&type=template&id=a47f61fe&scoped=true"
import script from "./langganan-chip.vue?vue&type=script&lang=js"
export * from "./langganan-chip.vue?vue&type=script&lang=js"

import "./langganan-chip.vue?vue&type=style&index=0&id=a47f61fe&scoped=true&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47f61fe"]])

export default __exports__